import $ from 'jquery';

import { Script, injector } from '../shared/injector.js';

injector.injectClass(class extends Script {
    onLoad() {
        $('.alert.dismissable').each(function () {
            const $alert = $(this);

            if (localStorage.getItem(`alert-${$alert.data('id')}`) !== 'closed') {
                $alert.show();
            }

            $alert.on('click', '.close', function () {
                if ($alert.find('.remember').prop('checked')) {
                    localStorage.setItem(`alert-${$alert.data('id')}`, 'closed');
                }

                $alert.fadeOut();
            });
        });
    }
});
